import { apiService } from '../../../services/apiService';
import {
  API_PATHS,
  getMerchantSoftDeletePath,
  getMerchantStatusPath,
} from '../../../utils/apiPaths';
import { createCompleteGridFetcher } from '../../../utils/fetchCompleteGridList';
import type { MerchantListRequest } from '../models/types';
import { buildMerchantsRequest, mapMerchantRow } from '../utils/utils';

export async function fetchMerchantsList(payload: MerchantListRequest) {
  const res: any = await apiService.post(API_PATHS.GET_MERCHANTS, payload);
  if (!res?.success) {
    throw new Error('Failed to fetch merchants');
  }

  const payloadData = res.data ?? {};
  const merchantContent = payloadData.content ?? res.data;

  if (!Array.isArray(merchantContent)) {
    throw new Error('Failed to fetch merchants');
  }

  const pageMeta =
    payloadData.page && typeof payloadData.page === 'object' && !Array.isArray(payloadData.page)
      ? payloadData.page
      : null;
  const reportedTotal = payloadData.totalElements ?? pageMeta?.totalElements ?? merchantContent.length;
  const totalElements = Number(reportedTotal);

  return {
    rows: merchantContent.map((m: Record<string, unknown>) => mapMerchantRow(m)),
    totalElements: Number.isFinite(totalElements) ? totalElements : merchantContent.length,
  };
}

export const fetchMerchantsGrid = createCompleteGridFetcher((
  options: Parameters<typeof buildMerchantsRequest>[0],
) => fetchMerchantsList(buildMerchantsRequest(options)));

export async function deleteMerchant(id: number) {
  await apiService.patch(getMerchantSoftDeletePath(id));
}

export async function updateMerchantStatus(id: number, status: string) {
  await apiService.patch(getMerchantStatusPath(id), null, {
    params: { status },
  });
}
